module.exports = __webpack_public_path__ + "img/logo-old.49d46c90.png";